// extracted by mini-css-extract-plugin
export default {"body":"ticketCancellationRequestModal_body__Uq+Hx"};